import { AxiosResponse } from 'axios';
import { FBaseService } from '@kasasa/fbase-components/lib';
import { FileLoadHistory } from '../fileloadhistory/FileLoadHistory';

export class ImportSummaryResource extends FBaseService {
  public async getImportSummariesForCycle(fiId: string, startDate: string, endDate: string): Promise<FileLoadHistory[]> {
    const response: AxiosResponse = await this.apiClient.get(
      `/api/rcx/director/${fiId}/import-summary`, { params: this.getRequestParams(startDate, endDate) },
    );
    const rows: FileLoadHistory[] = response.data.data;
    return rows;
  }

    getRequestParams = (startDate: string, endDate: string): URLSearchParams => {
      const params = new URLSearchParams();
      params.append('startDate', startDate);
      params.append('endDate', endDate);
      return params;
    }
}

export default ImportSummaryResource;
